import React from "react";
import { NavLink } from 'react-router-dom'
import "../css/editProfile.css"
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"

function EditProfile() {


  const params = useParams();
  const navigate = useNavigate();

  const email = params.email;


  const [firstname, setFirstname] = useState('');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');



  const handleChange = async () => {
    try {
      const response = await axios.put('https://petme.onrender.com/user/update', {
        firstname,
        name,
        email,
      });

      if (response.status === 200) {
        setMessage(response.data.message);
        setTimeout(() => {
          navigate("/home");
        }, 3000);
      }
    } catch (error) {
      console.log(error);
      setMessage('An error occurred while updating user information');
    }
  };

  if (message) {
    return (
      <div className="editProfile-msgDiv">
        <h2 className="editProfile-msg">{message}</h2>
      </div>
    )
  }

  return (

    <div>
      <div class="editProfile-div">
        <div class="editProfile-bg_img"></div>
        <div class="editProfile-content">
          <h2 class="editProfile-heading">Edit Profile</h2>
          <div class="editProfile-imgDiv" > 
          <i className="userProfile-imgIcon fa-solid fa-user"></i>
          {/* <img class="profile-profileImg" src={props.userImg} alt="profileImage" /> */}
          <label for="editProfile-upload-img" ><i class="editProfile-editImgIcon fa-solid fa-pen-to-square"></i></label>
          </div>
          <form action="" class="form editProfileForm">
            <input id="editProfile-upload-img" type="file" name="uploadFile" className="editProfile-box  editProfile-imgBox " placeholder="" />
            <input id="editProfile-first-name" type="name" name="firstname" class="editProfile-box" placeholder="first name" onChange={(e) => { setFirstname(e.target.value) }} /><br />
            <input id="editProfile-Last-name" type="name" name="name" class="editProfile-box" placeholder="last name" onChange={(e) => { setName(e.target.value) }} /><br />
            <NavLink className="editProfile-submitNavlink" to="" >
              <button type="button" class="editProfile-savetBtn" onClick={handleChange}>SAVE</button>
            </NavLink>
          </form>
        </div>
      </div>
    </div>
  );




};


export default EditProfile